module.exports = __webpack_public_path__ + "static/media/3DPPA31.8a38e55e.jpg";